module.exports = __webpack_public_path__ + "img/attivita_prjweb.3242e2da.png";